import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=722205cb"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"
import style0 from "./purchase.vue?vue&type=style&index=0&id=722205cb&prod&lang=scss"
import style1 from "./purchase.vue?vue&type=style&index=1&id=722205cb&prod&midia=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports